module.exports = __webpack_public_path__ + "img/filter_icon_3.1f90089c.webp";